import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls window to the top on every route (pathname) change.
 * Uses `behavior: 'instant'` so navigation feels immediate, even though
 * the global CSS `scroll-behavior: smooth` is enabled for in-page anchors.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Cross-browser instant jump to top
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch (_e) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
